export default [
    {
        'text': '확인',
        'state': 'CHECKED'
    },
    {
        'text': '미확인',
        'state': 'UNCHECKED'
    }
];



// WEBPACK FOOTER //
// ./src/api/passengerUsageProblemState.js